import { render, staticRenderFns } from "./ProductFilter.vue?vue&type=template&id=99d06364&scoped=true"
import script from "./ProductFilter.vue?vue&type=script&lang=js"
export * from "./ProductFilter.vue?vue&type=script&lang=js"
import style0 from "./ProductFilter.vue?vue&type=style&index=0&id=99d06364&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99d06364",
  null
  
)

export default component.exports